import React, { useEffect, useState } from 'react';
import styled from "styled-components";
import ReactSVG from "react-svg";
import LogoFerrarelle from "../Menus/ferrarelle.svg";


const AppLoaderContainer = styled.div`
    position: fixed;
    inset: 0;
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #EDF6F2;
    .app-loader__content {
        width: 17.5rem;
        text-align: center;
    }

    .app-loader__logo {
        display: block;
        width: 11.25rem;
        margin: 0 auto 1.5rem;
        svg {
            width: 100%;
            height: auto;
        }
        .ferrarelle--red {
            opacity: 1;
        }
        .ferrarelle--white {
            opacity: 0;
        }
    }

    .app-loader__bar {
        width: 100%;
        height: 6px;
        overflow: hidden;
        border-radius: 1.5rem;
        background: rgba(48,89,64,.1);
    }

    .app-loader__bar-fill {
        height: 100%;
        width: 0;
        border-radius: 1.5rem;
        background: #305940;
        transition: width .3s ease;
    }
`

const AppLoader = () => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setProgress(prev => {
                if (prev >= 90) {
                    return prev;
                }

                return prev + Math.random() * 15;
            });
        }, 200);

        return () => clearInterval(interval);
    }, []);

    return (
        <AppLoaderContainer>
            <div className="app-loader__content">
                <div className="app-loader__logo">
                    <ReactSVG
                        src={LogoFerrarelle}
                    />
                </div>
                <div className="app-loader__bar">
                    <div
                        className="app-loader__bar-fill"
                        style={{
                            width: `${progress}%`
                        }}
                    />
                </div>
            </div>
        </AppLoaderContainer>
    );
};

export default AppLoader;
